module.exports = __webpack_public_path__ + "img/freestyle-order-policy.39170738.png";